import { type GetPositionFn } from '..'

export const getOverlayPosition: GetPositionFn<'overlay'> = (targetOptions, context) => {
  const elBounding = context.videoElBounding
  let height
  // Shrink details container height to show player control
  if (targetOptions?.showPlayerControl === true) {
    const bottomSpace = context.ctx.embedTarget?.bottomSpace
    height = (bottomSpace != null && (typeof bottomSpace !== 'number' || bottomSpace !== 0)) ? `calc(${elBounding.height.value}px - ${bottomSpace})` : elBounding.height.value
  } else {
    height = elBounding.height.value
  }
  return {
    elementBounding: {
      top: elBounding.top.value + (targetOptions?.anchor === 'bottom' ? elBounding.height.value : 0),
      left: elBounding.left.value,
      width: elBounding.width.value,
      height
    }
  }
}
